import { StatusFilter, EntityFilter, translate } from '@aleph/shared-components';
import { RedditLevel } from 'wb-reddit/app/routes/superGrid/utils';
import { AdStatus, CampaignStatus, GroupStatus } from 'wb-reddit/graphql/generated';

export const LEVEL_NAME_FILTER = {
	[RedditLevel.AD_ACCOUNT]: 'adAccountName',
	[RedditLevel.CAMPAIGN]:   'campaignName',
	[RedditLevel.GROUP]:      'groupName',
	[RedditLevel.AD]:         'adName',
};

export const LEVEL_ID_FILTER = {
	[RedditLevel.AD_ACCOUNT]: 'clientId',
	[RedditLevel.CAMPAIGN]:   'campaignId',
	[RedditLevel.GROUP]:      'groupId',
	[RedditLevel.AD]:         'adId',
	creative:                 'creativeId',
};

export const getFilterConfig = (
	setFilters,
	getCurrentFilters,
	getEntityOptions,
	isAdmin,
	level,
) => ([
	{
		label:          translate('sc: filters.status.campaign', { defaultValue: 'Campaign status' }),
		value:          'campaignStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   RedditLevel.CAMPAIGN,
			filterName:    'campaignStatus',
			filterOptions: [
				{ value: CampaignStatus.Active, label: translate('sc: filters.status.active', { defaultValue: 'Active' }) },
				{ value: CampaignStatus.Paused, label: translate('sc: filters.status.paused', { defaultValue: 'Paused' }) },
				{ value: CampaignStatus.Deleted, label: translate('sc: filters.status.deleted', { defaultValue: 'Deleted' }) },
				{ value: CampaignStatus.Archived, label: translate('sc: filters.status.archived', { defaultValue: 'Archived' }) },
			],
			setFilters,
			getCurrentFilters,
		}),
	},
	{
		label:          translate('sc: filters.status.group', { defaultValue: 'Group status' }),
		value:          'groupStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   RedditLevel.GROUP,
			filterName:    'groupStatus',
			setFilters,
			getCurrentFilters,
			filterOptions: [
				{ value: GroupStatus.Active, label: translate('sc: filters.status.active', { defaultValue: 'Active' }) },
				{ value: GroupStatus.Paused, label: translate('sc: filters.status.paused', { defaultValue: 'Paused' }) },
				{ value: GroupStatus.Deleted, label: translate('sc: filters.status.deleted', { defaultValue: 'Deleted' }) },
				{ value: GroupStatus.Archived, label: translate('sc: filters.status.archived', { defaultValue: 'Archived' }) },
			],
		}),
	},
	{
		label:          translate('sc: filters.status.ad', { defaultValue: 'Ad status' }),
		value:          'adStatus',
		component:      StatusFilter,
		componentProps: ({
			filterLevel:   RedditLevel.AD_ACCOUNT,
			filterName:    'adStatus',
			setFilters,
			getCurrentFilters,
			filterOptions: [
				{ value: AdStatus.Active, label: translate('sc: filters.status.active', { defaultValue: 'Active' }) },
				{ value: AdStatus.Paused, label: translate('sc: filters.status.paused', { defaultValue: 'Paused' }) },
				{ value: AdStatus.Deleted, label: translate('sc: filters.status.deleted', { defaultValue: 'Deleted' }) },
				{ value: AdStatus.Archived, label: translate('sc: filters.status.archived', { defaultValue: 'Archived' }) },
			],
		}),
	},
	{
		label:          translate('sc: filters.entity.ad_accounts', { defaultValue: 'Ad accounts' }),
		value:          'clientId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: RedditLevel.AD_ACCOUNT,
			filterName:  'clientId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          translate('sc: filters.entity.campaigns', { defaultValue: 'Campaigns' }),
		value:          'campaignId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: RedditLevel.CAMPAIGN,
			filterName:  'campaignId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          translate('sc: filters.entity.groups', { defaultValue: 'Groups' }),
		value:          'groupId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: RedditLevel.GROUP,
			filterName:  'groupId',
			setFilters,
			getEntityOptions,
		}),
	},
	{
		label:          translate('sc: filters.entity.ads', { defaultValue: 'Ads' }),
		value:          'adId',
		component:      EntityFilter,
		componentProps: ({
			filterLevel: RedditLevel.AD,
			filterName:  'adId',
			setFilters,
			getEntityOptions,
		}),
	},
	...(
		level === RedditLevel.AD_ACCOUNT ? [
			{
				label:          translate('sc: filters.entity.advertiser', { defaultValue: 'Advertiser' }),
				value:          'agencyAccountId',
				component:      EntityFilter,
				componentProps: ({
					filterName: 'agencyAccountId',
					setFilters,
					getEntityOptions,
				}),
			},
			{
				label:          translate('sc: filters.entity.team', { defaultValue: 'Team' }),
				value:          'userGroupId',
				component:      EntityFilter,
				componentProps: ({
					filterName: 'userGroupId',
					setFilters,
					getEntityOptions,
				}),
			},
		] : []
	),
	...(
		isAdmin && level === RedditLevel.AD_ACCOUNT
			? [
				{
					label:          translate('sc: filters.entity.user', { defaultValue: 'User' }),
					value:          'userId',
					component:      EntityFilter,
					componentProps: ({
						filterName: 'userId',
						setFilters,
						getEntityOptions,
					}),
				},
			] : []
	),
]);
